import { ReferenceLinkMapper } from '../../../../common/mappers/ReferenceLinkMapper';
import { SeverityMapper } from '../../../../common/mappers/SeverityMapper';
import { Issue } from '../models/Issue';
import { InstanceCounters } from '../models/valueObject/InstanceCounters';

export class IssueMapper {
  private readonly linkMapper = new ReferenceLinkMapper();
  private readonly severityMapper = new SeverityMapper();

  mapGQLModel(data: any): Issue {
    return new Issue(
      data.number,
      data.title,
      this.severityMapper.mapSeverity(data.severity),
      data.explanation,
      data.consequences,
      data.access,
      data.expertise,
      data.resources,
      this.linkMapper.mapFromKbLink(data)
    );
  }

  mapInstanceCounters(data: any): InstanceCounters {
    return new InstanceCounters(
      data.highInstances.totalCount ?? 0,
      data.medInstances.totalCount ?? 0,
      data.lowInstances.totalCount ?? 0,
      data.passedInstances.totalCount ?? 0
    );
  }
}
